import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutComponent } from './about/about.component';
import { HomeComponent } from './home/home.component';
import { SongOverviewComponent } from './song-overview/song-overview.component';
import { VerseComponent } from './verse/verse.component';
import { PrivacyPolicyComponent } from './about/privacy-policy/privacy-policy.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', component: HomeComponent },
  { path: 'alle-vers', component: SongOverviewComponent },
  { path: 'vers/:handle', component: VerseComponent },
  { path: 'om-bordvers.dk', component: AboutComponent },
  { path: 'om-bordvers.dk/cookie-og-privatlivspolitik', component: PrivacyPolicyComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
